import angular from 'angular';
import template from './employerRequestDemoView.html';
import logger from '../../shared/logger';

export class EmployerRequestDemo {
    /* @ngInject */
    constructor($scope, $http, $window, RouteService) {
        const employerRequestDemoCtrl = this;
        employerRequestDemoCtrl.init = function () {
            $http.get('../resources/areaCode.json')
                .then((response) => {
                    employerRequestDemoCtrl.areaCode = response.data;
                })
                .catch(err => logger.error(err));

            employerRequestDemoCtrl.data = {};
        };
        employerRequestDemoCtrl.submit = function (form) {
            if (form.$invalid) {
                return;
            }
            RouteService.postRequestDemo(employerRequestDemoCtrl.data)
                .then(() => {
                    $window.history.back();
                })
                .catch(err => logger.error(err));
        };

        employerRequestDemoCtrl.back = function () {
            $window.history.back();
        };

        employerRequestDemoCtrl.init();
    }
}

export const EmployerRequestDemoConfiguration = {
    template,
    controller: EmployerRequestDemo,
    controllerAs: 'employerRequestDemoCtrl',
};

angular
    .module('TALENYA-FE')
    .component('employerRequestDemo', EmployerRequestDemoConfiguration);
